import { combineReducers } from "redux";

// Reducers:
import globalAppReducer from "./modules/globalModule";
import loginReducer from "../../pages/Login/loginModule";
import resetPasswordModule from "../../pages/ResetPassword/resetPasswordModule";
import homeReducer from "./modules/homeModule";
import bookingsReducer from "./modules/bookingsModule";
import dashboardReducer from "./modules/dashboardModule";
import errorFieldReducer from "./modules/errorFieldModule";
import loginsReducer from "./modules/loginsModule";
import offersReducer from "./modules/offersModule";
import settingsReducer from "./modules/settingsModule";
import employeesReducer from "./modules/employeesModule";
import marketplaceReducer from "./modules/marketplaceModule";

const rootReducer = combineReducers({
  global: globalAppReducer,
  login: loginReducer,
  resetPassword: resetPasswordModule,
  home: homeReducer,
  bookings: bookingsReducer,
  dashboard: dashboardReducer,
  errorField: errorFieldReducer,
  logins: loginsReducer,
  offers: offersReducer,
  settings: settingsReducer,
  employees: employeesReducer,
  marketplace: marketplaceReducer
});

export default rootReducer;
